<template>
  <div v-if="show_block" class="category" :class="layout === 'classic' ? 'bg-F pt11 pb11 ' : ''" name="分类-改">
    <!-- 样式一：原有多行两列分页 -->
    <template v-if="layout === 'classic'">
      <swiper id="categoryBanner" :options="category_swiper" style="height: 100%">
        <swiper-slide v-for="(item, index) of categorylisttd" :key="'c-' + index">
          <div
            style="position: relative"
            class="item"
            v-for="itemSon of item"
            :key="itemSon.index"
            :index="itemSon.index"
            @click="bannerClickHandle(itemSon)"
          >
            <img v-lazy="itemSon.img_path" />
            <p class="f12">{{ itemSon.ad_title }}</p>
            <div
              :path="
                (itemSon.ad_target || '') +
                (String(itemSon.ad_target || '').indexOf('?') >= 0 ? '&' : '?') +
                'sorce=2'
              "
              :username="'gh_5d4bb8e18b8b'"
              class="slide_cl_xcx"
              v-if="is_wx && (itemSon.ad_type == 7 || itemSon.ad_type == 8)"
            ></div>
          </div>
        </swiper-slide>
      </swiper>
    </template>

    <!-- 样式二：单行，每屏最多 5 个，手动滑动，自定义指示点 -->
    <template v-else-if="layout === 'row'">
      <swiper
        id="categoryBannerRow"
        ref="row_swiper"
        class="category_row_swiper"
        :options="row_swiper_options"
        style="height: 100%"
      >
        <swiper-slide v-for="(item, index) of categorylist" :key="'r-' + index" class="row_slide flex jc-c">
          <div class="row_slide_inner">
            <div
              class="item row_item pos-r"
              @click="bannerClickHandle(item)"
            >
              <img v-lazy="item.img_path" />
              <p class="f12">{{ item.ad_title }}</p>
              <div
                :path="
                  (item.ad_target || '') +
                  (String(item.ad_target || '').indexOf('?') >= 0 ? '&' : '?') +
                  'sorce=2'
                "
                :username="'gh_5d4bb8e18b8b'"
                class="slide_cl_xcx"
                v-if="is_wx && (item.ad_type == 7 || item.ad_type == 8)"
              ></div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div v-if="row_chunks.length > 1" class="row_pagination flex-jc-ac">
        <span
          v-for="(_, pi) in row_chunks"
          :key="'p-' + pi"
          class="row_dot"
          :class="{ row_dot_active: pi === row_active_index }"
        ></span>
      </div>
    </template>
  </div>
</template>

<script>
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import { isWeixin } from '../../../assets/common/js/config'
import adExposeMixin from '../js/adExposeMixin'

/**
 * layout=classic：原有多行两列分页
 * layout=row：单行，每屏 5 个，超出左滑；末屏不足 5 个则按需展示；底部指示点（当前红条、其余灰点）
 */
export default {
  name: 'homeCategoryIconSwiper',
  mixins: [adExposeMixin],
  components: {
    swiper: VueAwesomeSwiper.swiper,
    swiperSlide: VueAwesomeSwiper.swiperSlide
  },
  props: {
    categorylist: {
      type: Array,
      default: () => []
    },
    /** classic | row */
    layout: {
      type: String,
      default: 'classic'
    },
    /** 埋点 flowArea 前缀，如 channelZone */
    flow_area_prefix: {
      type: String,
      default: 'icon'
    }
  },
  data() {
    var that = this
    return {
      categorylisttd: [],
      is_wx: isWeixin() ? 1 : 0,
      row_active_index: 0,
      category_swiper: {
        autoplay: false,
        autoplayDisableOnInteraction: false,
        slidesPerView: 5,
        slidesPerGroup: 1,
        observer: true,
        observeParents: true,
        spaceBetween: 10,
        pagination: {
          el: '#newProSwiperPaginationOne',
          type: 'bullets'
        }
      },
      row_swiper_options: {
        autoplay: false,
        autoplayDisableOnInteraction: false,
        slidesPerView: 5,
        slidesPerGroup: 5,
        observer: true,
        observeParents: true,
        spaceBetween: 10,
        pagination: {
          el: '#newProSwiperPaginationOne',
          type: 'bullets'
        },
        on: {
          slideChangeTransitionStart() {
            that.row_active_index = this.snapIndex
          }
        }
      }
    }
  },
  computed: {
    row_chunks() {
      if (this.layout !== 'row') return []
      const list = Array.isArray(this.categorylist) ? this.categorylist : []
      const chunks = []
      for (let i = 0; i < list.length; i += 5) {
        chunks.push(list.slice(i, i + 5))
      }
      return chunks
    },
    show_block() {
      if (this.layout === 'classic') {
        return this.categorylisttd.length > 0
      }
      return this.row_chunks.length > 0
    }
  },
  watch: {
    categorylist: {
      handler() {
        this.ensure_indices()
        if (this.layout === 'classic') {
          this.build_category_slides()
        } else {
          this.row_active_index = 0
          this.$nextTick(() => {
            if (this.$refs.row_swiper && this.$refs.row_swiper.swiper) {
              this.$refs.row_swiper.swiper.slideTo(0, 0)
            }
          })
        }
        this.scheduleAdExposeBindHandle(this.bindIconExposeHandle)
      },
      deep: true,
      immediate: true
    },
    layout() {
      this.ensure_indices()
      if (this.layout === 'classic') {
        this.build_category_slides()
      } else {
        this.row_active_index = 0
        this.$nextTick(() => {
          if (this.$refs.row_swiper && this.$refs.row_swiper.swiper) {
            this.$refs.row_swiper.swiper.slideTo(0, 0)
          }
        })
      }
    }
  },
  methods: {
    ensure_indices() {
      const list = Array.isArray(this.categorylist) ? this.categorylist : []
      list.forEach((item, i) => {
        item.index = i
      })
      return list
    },
    build_category_slides() {
      this.categorylisttd = []
      const list = this.ensure_indices()
      const len = list.length
      this.category_swiper = {
        ...this.category_swiper,
        slidesPerView: len >= 5 ? 5 : len || 1
      }
      if (!len) return

      let aliVal = parseInt(len / 10),
        cardnum = 5,
        itemnum = 10,
        indextemp1 = 0,
        indextemp2 = 0
      for (let i = 0; i < aliVal; i++) {
        for (let j = 0; j < cardnum; j++) {
          let index1 = i * itemnum + j,
            index2 = i * itemnum + j + cardnum
          list[index1].index = index1
          list[index2].index = index2
          this.categorylisttd.push([list[index1], list[index2]])
          indextemp1 = index1
          indextemp2 = index2
        }
      }
      for (let i = 0; i < cardnum; i++) {
        let index1 = indextemp1 + (i + 1) + cardnum,
          index2 = indextemp2 + (i + 1) + cardnum
        if (indextemp1 == 0 && indextemp2 == 0) {
          index1 = i
          index2 = i + cardnum
        }
        if (list[index1] && list[index2]) {
          list[index1].index = index1
          list[index2].index = index2
          this.categorylisttd.push([list[index1], list[index2]])
        } else if (list[index1]) {
          list[index1].index = index1
          this.categorylisttd.push([list[index1]])
        } else {
          break
        }
      }
    },
    bannerClickHandle(itemSon) {
      this.$emit(
        'banner-click',
        itemSon,
        itemSon.index,
        this.flow_area_prefix +'-' + (+itemSon.index + 1)
      )
    },
    bindIconExposeHandle: function () {
      if (!this.$el) return
      var items = this.ensure_indices()
      var els = this.$el.querySelectorAll('.item')
      for (var i = 0; i < els.length; i++) {
        var idx = els[i].getAttribute('index')
        if (idx == null) idx = String(i)
        idx = parseInt(idx, 10)
        var item = items[idx] || items[i]
        if (els[i] && item) {
          this.bindAdExposeHandle(els[i], this.flow_area_prefix + '-' + ((item.index != null ? item.index : idx) + 1), item)
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.category {
  margin: 0.1rem 0.11rem 0;
  border-radius: 0.1rem;
  #categoryBanner {
    .item {
      text-align: center;
      margin-top: 0.12rem;
      &:first-child {
        margin-top: 0;
      }
      img {
        width: 0.36rem;
        height: 0.36rem;
        color: #333333;
        margin: 0 auto 0.06rem;
      }
    }
  }
}

.category_row_swiper {
  width: 100%;
}

.row_slide {
  height: auto;
}

.row_slide_inner {
  width: 100%;
  box-sizing: border-box;
  padding: 0 0.06rem;
}

.row_item {
  box-sizing: border-box;
  text-align: center;
  margin-top: 0;
  img {
    width: 0.36rem;
    height: 0.36rem;
    margin: 0 auto 0.06rem;
    display: block;
  }
}

.row_pagination {
  padding: 0.06rem 0 0;
  gap: 0.06rem;
}

.row_dot {
  display: inline-block;
  width: 0.05rem;
  height: 0.05rem;
  border-radius: 50%;
  background: #C4C4C4;
  transition: width 0.2s, border-radius 0.2s, background 0.2s;
  cursor: pointer;

  &.row_dot_active {
    width: 0.15rem;
    height: 0.05rem;
    border-radius: 0.04rem;
    background: #fc0324;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/components/homeCategoryIconSwiper.vue